/**
 * PII and sensitivity inventory for seller intake (Sell Your Car M2).
 * @deprecated Import from sellerIntakePrivacy.js — kept for backward compatibility.
 */
export {
  SELLER_INTAKE_SENSITIVE_FIELDS as SELLER_PII_FIELDS,
  SELLER_INTAKE_SENSITIVE_FIELDS,
  SELLER_INTAKE_ANALYTICS_FORBIDDEN_FIELDS as SELLER_ANALYTICS_BLOCKED_KEYS,
  SELLER_INTAKE_ANALYTICS_FORBIDDEN_FIELDS,
  SELLER_INTAKE_PUBLIC_FORBIDDEN_FIELDS,
  isSellerIntakeSensitiveField as isSensitiveSellerField,
  isSellerIntakeSensitiveField,
} from "./sellerIntakePrivacy";

export { SELLER_SENSITIVE_VEHICLE_FIELDS } from "./sellerIntakePrivacy";

/** Public-safe fields for analytics bucketing. */
export const SELLER_ANALYTICS_SAFE_FIELDS = Object.freeze([
  "sellerType",
  "city",
  "department",
  "vehicleMake",
  "vehicleModel",
  "vehicleYear",
  "vehicleTrim",
  "ownershipStatus",
  "hasPhotos",
  "currency",
  "sourcePage",
  "sourceComponent",
  "sourceAction",
  "currentPath",
  "utmSource",
  "utmMedium",
  "utmCampaign",
  "status",
]);
